module.exports = __webpack_public_path__ + "media/ROOM25sec.7bb7f23e.webm";